import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { CorrelationIdService } from "../services/correlation-id.service";
import { environment } from "../../environments/environment";

@Injectable()
export class CorrelationIdInterceptor implements HttpInterceptor {
  constructor(private readonly correlationIdService: CorrelationIdService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isHomeIaRequest =
      (environment.homeIaApiUrl && request.url.includes(environment.homeIaApiUrl)) ||
      request.url.includes("/api/home-ia");

    const existing = this.correlationIdService.get();
    const reqToSend = isHomeIaRequest && existing && !request.headers.has("X-Correlation-Id")
      ? request.clone({ setHeaders: { "X-Correlation-Id": existing } })
      : request;

    return next.handle(reqToSend).pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            const headerValue = event.headers.get("X-Correlation-Id") || undefined;
            this.correlationIdService.set(headerValue);
          }
        },
        error: (error) => {
          if (error instanceof HttpErrorResponse) {
            const headerValue = error.headers?.get("X-Correlation-Id") || undefined;
            this.correlationIdService.set(headerValue);
          }
        }
      })
    );
  }
}
